import { useRequest } from "../../../hooks/useRequest";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import { useEffect } from "react";
import routes from "../../../routes";

function useSolutionStripeLink(solutionId: string) {
  const { fetch, response, error, loading } = useRequest();

  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "Project successfully linked to Stripe!",
  );

  //TODO: temporary solution until we change to z-indexed floating alerts (not a priority)
  useEffect(() => {
    if (alert) {
      window.scrollTo(0, 0);
    }
  }, [alert]);

  const link = () => {
    fetch("PUT", routes.api.solution.stripeLink({ id: solutionId }));
  };

  return {
    link,
    loading,
    url: response?.data.internalUseOnly?.stripeUrl,
    alert,
    setAlert,
  };
}

export default useSolutionStripeLink;
